var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5175_15674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0396 49.182L65.3036 122.877L81.1175 115.725L56.2713 25.3796L45.0396 49.182Z",
    fill: "#4C5A81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0479 85.1897L41.3854 133.696L57.1965 126.544L39.2802 61.3865L28.0479 85.1897Z",
    fill: "#838EAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8799 23.5383L89.2239 112.058L126.03 95.4095C128.792 94.16 129.491 90.5429 127.382 88.3554L64.8799 23.5383Z",
    fill: "#445174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.424695 143.728C-0.952216 146.645 1.18668 149.998 4.39986 149.998C5.01156 149.998 5.62824 149.87 6.20977 149.607L33.2786 137.363L22.2886 97.3943L0.424695 143.728Z",
    fill: "#C8CCD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9402 26.892L85.1334 28.5056C84.048 30.6764 84.9277 33.3157 87.0986 34.4011C89.2735 35.4886 91.911 34.6024 92.9941 32.4359L93.8009 30.8226C98.3655 21.6943 98.0122 10.9857 92.8564 2.17759C91.6301 0.0829296 88.9381 -0.620759 86.844 0.604984C84.7496 1.83102 84.0456 4.52273 85.2717 6.61739C88.9208 12.8516 89.171 20.4307 85.9402 26.892Z",
    fill: "#AF8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.825 57.1459C139.017 51.9901 128.309 51.6362 119.18 56.2011L117.566 57.0079C115.395 58.0933 114.516 60.7329 115.601 62.9034C116.371 64.4435 117.923 65.3335 119.535 65.3335C120.804 65.3335 121.481 64.8765 123.11 64.0618C129.572 60.831 137.151 61.0812 143.385 64.7306C145.479 65.9561 148.171 65.253 149.397 63.158C150.623 61.0636 149.919 58.3719 147.825 57.1459Z",
    fill: "#AF8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.605 0.00292969C143.178 0.00292969 141.21 1.97045 141.21 4.39732V4.69028C141.21 7.43649 138.976 9.6706 136.23 9.6706C127.897 9.6706 122.168 16.1898 122.168 23.4397C122.168 25.8666 124.135 27.8341 126.562 27.8341C128.989 27.8341 130.957 25.8666 130.957 23.4397C130.957 20.6935 133.191 18.4594 135.937 18.4594C143.819 18.4594 149.999 12.5097 149.999 4.39732C149.999 1.97045 148.032 0.00292969 145.605 0.00292969Z",
    fill: "#AF8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.506 16.116C114.933 16.116 116.901 14.1484 116.901 11.7214C116.901 9.29448 114.933 7.3269 112.506 7.3269C110.055 7.3269 108.11 9.31499 108.11 11.7214C108.11 14.1484 110.079 16.116 112.506 16.116Z",
    fill: "#AF8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.819 46.5835C110.246 46.5835 112.213 44.6159 112.213 42.189C112.213 39.762 110.246 37.7944 107.819 37.7944C105.367 37.7944 103.423 39.7825 103.423 42.189C103.423 44.6162 105.392 46.5835 107.819 46.5835Z",
    fill: "#AF8EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.681 37.5015C142.681 35.0941 140.734 33.1069 138.284 33.1069C135.857 33.1069 133.891 35.0745 133.891 37.5015C133.891 39.9284 135.86 41.896 138.287 41.896C140.714 41.896 142.681 39.9287 142.681 37.5015Z",
    fill: "#AF8EFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5175_15674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo);
export default __webpack_public_path__ + "static/media/co.cf6ea7cee6342e56cb7aa5e8ee0374b0.svg";
export { ForwardRef as ReactComponent };